// extracted by css-extract-rspack-plugin
export default {"cls1":"FullScreenPremiumModal-cls1_OZ2","cls2":"FullScreenPremiumModal-cls2_Mmn FullScreenPremiumModal-cls1_OZ2"};